import { render, staticRenderFns } from "./admin-shifts.vue?vue&type=template&id=e1df42ce&scoped=true"
import script from "./admin-shifts.vue?vue&type=script&lang=js"
export * from "./admin-shifts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1df42ce",
  null
  
)

export default component.exports